'use client';
import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';
const CaretRightFillSvg = forwardRef(
  (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      ref={ref}
      {...props}
    >
      <path d="M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" />
    </svg>
  )
);
type ComponentProps = Omit<SvgIconProps, 'inheritViewbox' | 'component'>;
function Component(
  props: ComponentProps,
  ref: React.ForwardedRef<SVGSVGElement>
) {
  return (
    <SvgIcon
      data-testid="CaretRightFillIcon"
      ref={ref}
      {...props}
      component={CaretRightFillSvg}
      inheritViewBox
    />
  );
}
Component.displayName = 'CaretRightFillIcon';
Component.muiName = SvgIcon.muiName;
export default React.memo(forwardRef(Component));
